<template>
<div>
  <van-field
    :label="label"
    v-model="showVal"
    is-link
    readonly
    :rules="rules"
    :required="required"
    :disabled="disabled"
    @click="handleClick"
  />
  <van-action-sheet
    :title="title"
    v-model="show"
    :actions="items"
    cancel-text="取消"
    close-on-click-action
    @select="handleItemsSelect"
    @cancel="show=false"
  />
</div>
</template>

<script>

export default {
  props: {
    value: [String, Number],
    name: String,
    title: String,
    type: String,
    label: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default() {
        return []
      }
    }
  },
  model: {
    event: 'input',
  },
  data() {
    return {
      showVal: '',
      id: '',
      items: [],
      show: false,
    }
  },
  watch: {
    name(val) {
      this.showVal = val
    }
  },
  mounted() {
    this.showVal = this.name
    this.getItems()
  },
  methods: {
    handleClick() {
      if(this.disabled) return
      this.show = true
    },
    getItems() {
      const dictItems =  this.$store.state.dict[`${this.type}`] || []
      this.items = dictItems.map(item => {
        return {name: `${item.dictLabel}`, id: item.dictValue}
      })
    },
    handleItemsSelect(customer) {
      const {name, id} = customer
      this.showVal = name
      this.id = id
      this.$emit('input', id)
      this.$emit('selected', name)
    },
  },
}
</script>

<style>

</style>